import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import LogoWhite from '../assets/Logo.svg';

function Nav({ initialCollapsed = false }) {
  const [navScrolled, setNavScrolled] = useState(initialCollapsed);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const handleContactClick = () => {
    setIsContactOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseClick = () => {
    setIsContactOpen(false);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavScrolled(true);
      } else {
        setNavScrolled(initialCollapsed);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [initialCollapsed]);

  return (
    <div>
      <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300
        ${navScrolled || isContactOpen ? 'h-14' : 'h-24'}
        ${navScrolled ? 'bg-black/60 backdrop-blur-md' : 'bg-transparent'}
      `}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-full">
          <div className="flex-shrink-0">
            <Link to='/'>
              <img
                src={LogoWhite}
                alt="Logo"
                className="h-4"
              />
            </Link>
          </div>
          <div>
            <button onClick={isContactOpen ? handleCloseClick : handleContactClick} className='text-base font-medium text-white'>
              {isContactOpen ? "Close" : "Contact"}
            </button>
          </div>
        </div>
      </nav>

      {isContactOpen && (
        <div className="fixed inset-0 bg-customCharcoal/50 backdrop-blur-md text-white flex items-center justify-center z-40 animate-fade-in">
          <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl mb-8">Let's talk</h1>
            <p className="text-lg text-white/70 mb-12">
              Got a defined brief or something still taking shape? You can loop us in at pitch stage - there’s no cost unless the project goes ahead. We’ll help you work through feasibility, costs, and delivery, so what you’re proposing is practical and deliverable.
            </p>
            <div className="space-y-2">
              <p className="text-xl">
                <a href="mailto:hello@clarkesthird.com" className="hover:text-white/70 transition-colors">
                  hello@clarkesthird.com
                </a>
              </p>
              <p className="text-xl">
                <a href="tel:+16464504277" className="hover:text-white/70 transition-colors">
                  +1 (646) 450-4277
                </a>
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Nav;